{
  "common": {
    "next": "Weiter",
    "back": "Zurück",
    "loading": "Lade …",
    "submit": "Verbindlich absenden",
    "submitting": "Wird gesendet …",
    "select": "— bitte wählen —",
    "yes": "Ja",
    "dash": "—"
  },
  "nav": {
    "title": "Mandanten-Onboarding",
    "subtitle": "GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB",
    "impressum": "Impressum",
    "datenschutz": "Datenschutz"
  },
  "lang": {
    "label": "Sprache",
    "de": "Deutsch",
    "en": "English",
    "ar": "العربية",
    "fr": "Français"
  },
  "onboarding": {
    "title": "Mandanten-Onboarding",
    "subtitle": "Bitte schildern Sie kurz Ihren Sachverhalt. Sie können jederzeit unterbrechen — Ihre Eingaben werden automatisch gespeichert.",
    "submittedTitle": "Vielen Dank — Ihre Anfrage liegt uns vor.",
    "submittedBody": "Ihre Unterlagen wurden übermittelt. Wir prüfen den Sachverhalt und melden uns innerhalb weniger Werktage.",
    "submittedDashboardPrefix": "Sie können den Status jederzeit in Ihrem ",
    "submittedDashboardLink": "Dashboard",
    "submittedDashboardSuffix": " einsehen oder dort einen Online-Termin vereinbaren.",
    "steps": {
      "sachverhalt": "Sachverhalt",
      "fragebogen": "Fragebogen",
      "gegenseite": "Gegenseite",
      "vollmacht": "Vollmacht",
      "uploads": "Unterlagen",
      "review": "Prüfen & Absenden"
    },
    "sachverhalt": {
      "rechtsgebietLabel": "Rechtsgebiet",
      "beschreibungLabel": "Kurze Beschreibung Ihres Anliegens",
      "beschreibungPlaceholder": "Was ist passiert? Wer ist beteiligt? Welche Schritte haben Sie bisher unternommen?",
      "counter": "{{chars}} / 20.000 Zeichen",
      "minHint": "mindestens 3 Zeichen zum Weitergehen"
    },
    "gegenseite": {
      "hint": "Wenn aktuell noch keine Gegenseite bekannt ist, tragen Sie bitte „—\" ein.",
      "nameLabel": "Name / Firma der Gegenseite",
      "anschriftLabel": "Anschrift (sofern bekannt)",
      "vertretenLabel": "Anwaltliche Vertretung der Gegenseite (sofern bekannt)"
    },
    "vollmacht": {
      "p1": "Im weiteren Verlauf benötigen wir eine schriftliche anwaltliche Vollmacht. Sie wird Ihnen nach Sichtung des Sachverhalts zur Unterschrift zugeleitet (entweder elektronisch oder als Brief).",
      "p2": "Bereits jetzt erklären Sie bitte Ihr grundsätzliches Einverständnis, dass die Kanzlei GQL Gussone Quecke Legal die Sache prüft und Sie gegebenenfalls als Mandant aufnimmt.",
      "checkbox": "Ich beauftrage GQL Gussone Quecke Legal mit der Sichtung des hier dargestellten Sachverhalts und der Vorbereitung eines anwaltlichen Mandats."
    },
    "uploads": {
      "hint": "Bitte laden Sie alle relevanten Unterlagen hoch — insbesondere Ausweis (Identifikation gem. GwG), Vollmacht (falls schon erteilt), Korrespondenz mit der Gegenseite und sonstige Beweismittel."
    },
    "review": {
      "title": "Zusammenfassung",
      "rechtsgebiet": "Rechtsgebiet",
      "sachverhalt": "Sachverhalt",
      "gegenseite": "Gegenseite",
      "vertretenDurch": "Vertreten durch: {{name}}",
      "vollmachtErklaerung": "Vollmacht-Erklärung",
      "fragebogen": "Fragebogen",
      "unterlagen": "Unterlagen ({{count}})",
      "notReady": "Bitte vorher Sachverhalt, Gegenseite und Vollmacht-Erklärung ausfüllen."
    },
    "errors": {
      "alreadySubmitted": "Sie haben bereits abgesendet.",
      "submitFailed": "Absenden fehlgeschlagen — bitte später erneut.",
      "unexpected": "Unerwarteter Fehler."
    }
  },
  "rechtsgebiete": {
    "arbeitsrecht": "Arbeitsrecht",
    "mietrecht": "Mietrecht",
    "familienrecht": "Familienrecht",
    "verkehrsrecht": "Verkehrsrecht",
    "strafrecht": "Strafrecht",
    "kartellrecht": "Kartellrecht",
    "vergaberecht": "Vergaberecht",
    "verwaltungsrecht": "Verwaltungsrecht",
    "sonstiges": "Sonstiges"
  },
  "upload": {
    "kategorieLabel": "Kategorie der Datei",
    "kategorien": {
      "ausweis": "Ausweis / Identifikation",
      "vollmacht": "Vollmacht / Auftrag",
      "korrespondenz": "Korrespondenz (Briefe, Mails)",
      "beweis": "Beweismittel / Unterlagen",
      "sonstiges": "Sonstiges"
    },
    "dropHint": "PDF, JPG, PNG, HEIC, ZIP · max. 10 MB pro Datei",
    "tooBig": "Datei \"{{name}}\" ist größer als 10 MB.",
    "failed": "Upload fehlgeschlagen — bitte erneut versuchen.",
    "remove": "Entfernen",
    "removeAria": "{{name}} entfernen"
  },
  "questionnaire": {
    "title": "Fragen zu Ihrem Fall",
    "intro": "Bitte beantworten Sie die folgenden Fragen so vollständig wie möglich. Ihre Angaben helfen uns, Ihren Fall richtig einzuschätzen.",
    "optionalHint": "(optional)",
    "requiredHint": "Pflichtfeld",
    "selectPlaceholder": "— bitte wählen —",
    "loading": "Fragebogen wird geladen …",
    "answeredCount": "{{answered}} von {{total}} beantwortet"
  },
  "legalNotice": {
    "deAuthoritative": "Dieser rechtliche Text ist verbindlich in deutscher Sprache abgefasst. Übersetzungen dienen nur dem besseren Verständnis."
  },
  "register": {
    "title": "Registrierung",
    "subtitle": "Damit wir Ihre Anfrage strukturiert aufnehmen können, registrieren Sie sich bitte mit Ihren Stammdaten. Sie erhalten anschließend eine Bestätigungsmail.",
    "vorname": "Vorname",
    "nachname": "Nachname",
    "geburtsdatum": "Geburtsdatum",
    "email": "E-Mail-Adresse",
    "required": "Pflichtfeld",
    "einwilligungRequired": "Einwilligung erforderlich",
    "einwilligung": "Ich willige in die Verarbeitung meiner Daten zur Anbahnung eines Mandats ein. Die Daten werden vertraulich behandelt und unterliegen der anwaltlichen Verschwiegenheitspflicht (§ 43a Abs. 2 BRAO).",
    "captchaPlease": "Bitte das CAPTCHA bestätigen.",
    "submit": "Registrierung absenden",
    "submitting": "Bitte warten …",
    "haveAccount": "Bereits registriert?",
    "login": "Anmelden",
    "errCaptcha": "Bot-Schutz hat den Versuch abgelehnt. Bitte CAPTCHA neu lösen.",
    "errValidation": "Bitte prüfen Sie die Eingabefelder.",
    "errRateLimit": "Zu viele Registrierungen von dieser Verbindung. Bitte später erneut.",
    "errGeneric": "Ein Fehler ist aufgetreten. Bitte später erneut.",
    "errUnexpected": "Ein unerwarteter Fehler ist aufgetreten."
  },
  "login": {
    "title": "Anmeldung",
    "subtitle": "Sie erhalten einen einmaligen Login-Link per E-Mail. Keine Passworteingabe nötig.",
    "email": "E-Mail-Adresse",
    "required": "Pflichtfeld",
    "captchaPlease": "Bitte das CAPTCHA bestätigen.",
    "submit": "Login-Link anfordern",
    "submitting": "Bitte warten …",
    "consumingTitle": "Anmeldung läuft …",
    "wait": "Bitte einen Moment Geduld.",
    "sentTitle": "Login-Link wurde gesendet",
    "sentBody": "Wenn die E-Mail-Adresse registriert ist, haben wir einen Login-Link geschickt. Der Link ist 15 Minuten gültig.",
    "errorTitle": "Anmeldung nicht möglich",
    "errInvalid": "Der Login-Link ist ungültig oder abgelaufen.",
    "errGeneric": "Login fehlgeschlagen.",
    "errRequest": "Anfrage fehlgeschlagen.",
    "errCaptcha": "Bot-Schutz hat den Versuch abgelehnt.",
    "newLink": "Neuen Link anfordern",
    "register": "Registrieren",
    "noAccount": "Noch nicht registriert?",
    "registerNow": "Jetzt registrieren"
  },
  "verify": {
    "checkingTitle": "Bestätigung wird geprüft …",
    "wait": "Bitte einen Moment Geduld.",
    "successTitle": "E-Mail bestätigt",
    "successBody": "Vielen Dank — Ihr Zugang ist freigeschaltet. Sie werden zum Onboarding weitergeleitet …",
    "errorTitle": "Bestätigung nicht möglich",
    "errInvalid": "Der Bestätigungslink ist ungültig oder bereits abgelaufen.",
    "errGeneric": "Bestätigung fehlgeschlagen.",
    "noToken": "Kein Token im Link.",
    "registerNew": "Neu registrieren",
    "requestLogin": "Login-Link anfordern"
  },
  "verifySent": {
    "title": "Bestätigungsmail wurde gesendet",
    "bodyWithEmail": "Wir haben einen Bestätigungslink an {{email}} geschickt. Bitte klicken Sie darauf, um den Onboarding-Bereich zu öffnen.",
    "bodyNoEmail": "Wir haben Ihnen einen Bestätigungslink per E-Mail geschickt. Bitte klicken Sie darauf, um den Onboarding-Bereich zu öffnen.",
    "validity": "Der Link ist 24 Stunden gültig. Schauen Sie ggf. in den Spam-Ordner.",
    "notArrivedPrefix": "Falls die Mail nicht ankommt, können Sie sich ",
    "notArrivedLink": "erneut registrieren",
    "notArrivedSuffix": "."
  },
  "invite": {
    "checkingTitle": "Einladung wird geprüft …",
    "wait": "Bitte einen Moment Geduld.",
    "successTitle": "Willkommen",
    "successBody": "Ihr Zugang ist freigeschaltet. Sie werden zum Onboarding weitergeleitet …",
    "errorTitle": "Einladung nicht möglich",
    "errorInvalid": "Der Einladungslink ist ungültig oder abgelaufen.",
    "errorGeneric": "Einlösen fehlgeschlagen.",
    "loginLink": "Stattdessen Login-Link anfordern"
  },
  "dashboard": {
    "loading": "Lade …",
    "notLoggedIn": "Nicht angemeldet",
    "welcome": "Willkommen, {{name}}.",
    "subtitle": "Hier können Sie Ihre Onboarding-Daten bearbeiten oder einen Termin vereinbaren.",
    "subtitleWithTax": "Hier können Sie Ihre Onboarding-Daten bearbeiten, die Steuerangaben 2021 und 2022 ergänzen oder einen Termin vereinbaren.",
    "name": "Name",
    "email": "E-Mail",
    "verifiedSince": "Verifiziert seit",
    "logout": "Abmelden",
    "requestH": "Ihre Mandanten-Anfrage",
    "submitted": "Ihre Anfrage wurde übermittelt. Wir prüfen den Sachverhalt und melden uns innerhalb weniger Werktage.",
    "draftHint": "Sie haben einen begonnenen Onboarding-Entwurf. Sie können dort weitermachen.",
    "continue": "Onboarding fortsetzen",
    "startHint": "Beschreiben Sie uns Ihren Sachverhalt, laden Sie relevante Unterlagen hoch — wir prüfen die Sache und melden uns.",
    "start": "Onboarding starten",
    "taxH": "Steuerformular Haidar 2021 und 2022",
    "taxHint": "Ergänzen Sie hier die noch fehlenden Angaben für die Feststellungs- und Einkommensteuererklärungen 2021 und 2022 und laden Sie die dazugehörigen Unterlagen hoch. Ihre Eingaben werden automatisch zwischengespeichert.",
    "taxStart": "Steuerformular öffnen",
    "taxContinue": "Steuerformular fortsetzen",
    "taxSubmitted": "Das Steuerformular wurde übermittelt. Die Angaben werden nun geprüft; aus diesem Portal erfolgt keine Übermittlung an ELSTER oder das Finanzamt.",
    "nachreichungH": "Unterlagen nachreichen",
    "nachreichungHint": "Sie können hier weitere Unterlagen (Kündigungsschreiben, Aufhebungsverträge, Arbeitsvertrag, Gehaltsabrechnungen, Korrespondenz etc.) hochladen. Die Dateien werden direkt in Ihre Akte übertragen, sofern bereits angelegt.",
    "terminH": "30-Minuten-Online-Termin vereinbaren",
    "terminHint": "Sie können direkt einen 30-Minuten-Slot mit Rechtsanwalt Moritz Quecke buchen. Der Termin findet als Microsoft-Teams-Meeting statt; den Link erhalten Sie nach der Buchung per E-Mail.",
    "bookButton": "Termin buchen (öffnet neues Fenster)",
    "bookInline": "Oder direkt hier im Fenster buchen",
    "bookFrameTitle": "Termin buchen",
    "bookSoon": "Die Buchungsseite wird gerade eingerichtet. Sobald sie verfügbar ist, erscheint hier ein Buchungs-Button."
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "subtitle": "Die aufgerufene Seite existiert nicht.",
    "toRegister": "Zur Registrierung"
  },
  "intake": {
    "title": "Fragen zu Ihrem Fall",
    "subtitle": "Bitte beantworten Sie die folgenden Fragen, laden Sie angeforderte Unterlagen hoch und erteilen Sie die Vollmacht. Ihre Eingaben werden automatisch gespeichert.",
    "notReady": "Bitte alle Pflichtfragen beantworten und die Vollmacht erteilen.",
    "noQuestionnaireTitle": "Kein Fragebogen zugewiesen",
    "noQuestionnaire": "Diesem Zugang ist kein fallspezifischer Fragebogen zugewiesen. Bitte nutzen Sie die allgemeine Registrierung."
  }
}
